export default function Footer() {
  return (
    <footer className="bg-black text-white">
      {/* Ana Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Müşteri Hizmetleri */}
          <div>
            <h3 className="font-bold mb-4 text-sm">MÜŞTERİ HİZMETLERİ</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:underline cursor-pointer">Sık Sorulan Sorular</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Mağazalar</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Kampanyalar</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Bize Ulaşın</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Gizlilik Politikası</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Kişisel Verilerin Korunması</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Kullanım Koşulları</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Site Haritası</a></li>
            </ul>
          </div>

          {/* PUMA Hakkında */}
          <div>
            <h3 className="font-bold mb-4 text-sm">PUMA HAKKINDA</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:underline cursor-pointer">Kariyer</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Şirket Hakkında</a></li>
              <li><a href="#" className="hover:underline cursor-pointer">Bilgi Toplumu Hizmetleri</a></li>
            </ul>
          </div>

          {/* Sosyal Medya */}
          <div>
            <h3 className="font-bold mb-4 text-sm">TAKİP ET</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-gray-400 cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="#" className="hover:text-gray-400 cursor-pointer">
                <i className="ri-twitter-fill text-2xl"></i>
              </a>
              <a href="#" className="hover:text-gray-400 cursor-pointer">
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a href="#" className="hover:text-gray-400 cursor-pointer">
                <i className="ri-pinterest-fill text-2xl"></i>
              </a>
              <a href="#" className="hover:text-gray-400 cursor-pointer">
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-bold mb-4 text-sm">PUMA FAM ÜYESİ OL</h3>
            <p className="text-sm mb-4">İlk Siparişinde %15 İndirim Kazan!</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="E-posta" 
                className="flex-1 px-4 py-2 text-black text-sm"
              />
              <button className="bg-white text-black px-6 py-2 font-bold hover:bg-gray-200 transition whitespace-nowrap cursor-pointer">
                ABONE OL
              </button>
            </div>
          </div>
        </div>

        {/* Alt Footer */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <div className="mb-4 md:mb-0">
              <img 
                src="https://static.readdy.ai/image/1bbfa2f32c0e742fa111fb11370c4024/cb89370780a4b5b8aeed7efe5837b533.png" 
                alt="PUMA" 
                className="h-10 mb-4"
              />
              <p className="text-gray-400">Copyright © 2022 PUMA</p>
            </div>
            <div className="flex items-center space-x-4">
              <button className="flex items-center space-x-2 border border-gray-700 px-4 py-2 hover:border-gray-500 cursor-pointer">
                <img 
                  src="https://tr.puma.com/media/webcomponents/locale/default/flag-round-250_1__1.png" 
                  alt="Turkey" 
                  className="w-6 h-6 rounded-full"
                />
                <span>Turkey</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
